export type CroModalId = "horeca" | "fitness" | "exit_yclients";

const STORAGE_KEY = "tezam:cro-modal-seen";
const CAP_MS = 3 * 24 * 60 * 60 * 1000;

type SeenMap = Partial<Record<CroModalId, number>>;

function readSeen(): SeenMap {
    if (typeof window === "undefined") return {};
    try {
        return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}") as SeenMap;
    } catch {
        return {};
    }
}

export function canShowCroModal(id: CroModalId): boolean {
    const ts = readSeen()[id];
    if (!ts) return true;
    return Date.now() - ts > CAP_MS;
}

export function markCroModalShown(id: CroModalId): void {
    if (typeof window === "undefined") return;
    const next = { ...readSeen(), [id]: Date.now() };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

declare global {
    interface Window {
        gtag?: (...args: unknown[]) => void;
        ym?: (id: number, method: string, ...rest: unknown[]) => void;
    }
}

export function trackCroEvent(eventName: string, params: Record<string, string | number | undefined> = {}) {
    if (typeof window === "undefined") return;
    const cleaned = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== ""),
    ) as Record<string, string | number>;

    try {
        window.gtag?.("event", eventName, cleaned);
    } catch {
        /* ignore */
    }
    try {
        window.ym?.(101022905, "reachGoal", eventName, cleaned);
    } catch {
        /* ignore */
    }
}
